import React from 'react';
import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
  View,
} from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';

import './style.scss';

const ParagraphTopics = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed'], '');
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], t('general.readMore'));

  return (
    <div className="ParagraphTopics">
      {(title || text) && (
        <Container>
          <div className="row">
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              {title && (
                <div className="ParagraphTopics__title">
                  <h1>{title}</h1>
                </div>
              )}

              {text && (
                <div className="ParagraphTopics__text">
                  <WysiwygField
                    property="schema:text"
                    html={text}
                  />
                </div>
              )}
            </div>
          </div>
        </Container>
      )}

      <View
        id="topics"
        display="block_1"
      />

      {linkUrl && (
        <Container>
          <div className="row">
            <div className="col-12">
              <div className="ParagraphTopics__link">
                <CoreLink className="Button Button--secondary" to={linkUrl}>
                  {linkTitle} <i className="icon icon-arrow-right" />
                </CoreLink>
              </div>
            </div>
          </div>
        </Container>
      )}
    </div>
  );
};

export default ParagraphTopics;
